import React from 'react';
import {
  StyledSlideUpFullScreenPopupWrapper,
  StyledSlideUpPopupWrapper,
} from '../styles';
import { E_POPUP_STATE } from 'src/utils/enum';

type TSlideUpPopupProps = {
  isOpen: E_POPUP_STATE;
  children?: React.ReactNode;
  zIndex?: number;
  overflow?: 'Y' | 'N';
};

/**
 * @names 밑에서 위로 올라오는 팝업
 * @params isOpen 팝업 열고 닫기 여부
 */
export function SlideUpPopupWrapper(
  props: TSlideUpPopupProps,
): React.ReactElement {
  return (
    <StyledSlideUpPopupWrapper
      id="slideupWrapper"
      zIndex={props.zIndex}
      className={props.isOpen === E_POPUP_STATE.OPEN ? 'open' : 'close'}
      overflow={props.overflow}
    >
      {props.children}
    </StyledSlideUpPopupWrapper>
  );
}

type TSlideUpFullScreenPopupProps = {
  isOpen: E_POPUP_STATE;
  zIndex?: number;
  children?: React.ReactNode;
};

/**
 * @names 밑에서 위로 올라오는 풀스크린 팝업
 * @params isOpen 팝업 열고 닫기 여부
 */
export function SlideUpFullScreenPopupWrapper(
  props: TSlideUpFullScreenPopupProps,
): React.ReactElement {
  return (
    <StyledSlideUpFullScreenPopupWrapper
      zIndex={props.zIndex}
      className={props.isOpen === E_POPUP_STATE.OPEN ? 'open' : 'close'}
    >
      {props.children}
    </StyledSlideUpFullScreenPopupWrapper>
  );
}
